import * as React from 'react';
import { useOutlet, useOutletContext } from 'react-router';

export interface AppOutletContextValue {
    depth: number;
}

export function useAppOutletContext(contextValue?: AppOutletContextValue): AppOutletContextValue {
    const parentContext = useOutletContext<AppOutletContextValue>();
    const context = contextValue ?? parentContext;
    if (context == null) {
        throw new Error(`Disconnected outlet context`);
    }
    return context;
}

export function useAppOutlet(contextValue?: AppOutletContextValue): React.ReactElement | null {
    const outletContext = useAppOutletContext(contextValue);
    const nextDepth = outletContext.depth + 1;
    const nextContext = { ...outletContext, depth: nextDepth };
    return useOutlet(nextContext);
}

export interface AppOutletProps {
    context?: AppOutletContextValue;
}

export function AppOutlet(props: AppOutletProps): React.ReactElement {
    const outlet = useAppOutlet(props.context);
    return <>{outlet}</>;
}
